/**
 * Utility function to fetch user's IP address
 * Uses a public API service to get the user's IP address
 */
export const fetchUserIpAddress = async (): Promise<string> => {
  try {
    const response = await fetch('https://api.ipify.org?format=json')
    const data = await response.json()
    return data.ip || 'Unknown'
  } catch (error) {
    console.error('Failed to fetch IP address:', error)
    return 'Unknown'
  }
}

